/*
 * @Author: chengyu
 * @Date: 2022-09-22 10:33:15
 * @Description: 枚举
 */
/**
 * 环境变量
 */
export var EnvEnum;
(function (EnvEnum) {
    EnvEnum["FAT"] = "fat";
    EnvEnum["UAT"] = "uat";
    EnvEnum["PRE"] = "pre";
    EnvEnum["PRO"] = "pro";
})(EnvEnum || (EnvEnum = {}));
/**
 * 运行环境
 */
export var ContextEnvEnum;
(function (ContextEnvEnum) {
    ContextEnvEnum["TARO"] = "taro";
    ContextEnvEnum["ALIPAY"] = "alipay";
    ContextEnvEnum["WECHAT"] = "wechat";
    ContextEnvEnum["BROWSER"] = "browser";
    ContextEnvEnum["NODE"] = "node";
})(ContextEnvEnum || (ContextEnvEnum = {}));
/**
 * 地图服务类型
 */
export var ServiceTypeEnum;
(function (ServiceTypeEnum) {
    ServiceTypeEnum["HELLO"] = "HELLO";
    ServiceTypeEnum["GAODE"] = "GAODE";
})(ServiceTypeEnum || (ServiceTypeEnum = {}));
/**
 * 返回值为 0 或 1，0 表示请求失败；1 表示请求成功。
 */
export var GaodeServiceStatus;
(function (GaodeServiceStatus) {
    GaodeServiceStatus["error"] = "0";
    GaodeServiceStatus["success"] = "1";
})(GaodeServiceStatus || (GaodeServiceStatus = {}));
/**
 * 服务优先级
 */
export var FirstServicesEnum;
(function (FirstServicesEnum) {
    FirstServicesEnum["lbs"] = "lbs";
    FirstServicesEnum["amap"] = "amap";
})(FirstServicesEnum || (FirstServicesEnum = {}));
/**
 * 缓存类型枚举
 */
export var CacheTypeEnum;
(function (CacheTypeEnum) {
    CacheTypeEnum["http"] = "httpCache";
    CacheTypeEnum["result"] = "resultCache";
    CacheTypeEnum["geo"] = "geoHashCache";
})(CacheTypeEnum || (CacheTypeEnum = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29yZS9lbnVtcy9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7OztHQUlHO0FBRUg7O0dBRUc7QUFDSCxNQUFNLENBQU4sSUFBWSxPQUtYO0FBTEQsV0FBWSxPQUFPO0lBQ2pCLHNCQUFXLENBQUE7SUFDWCxzQkFBVyxDQUFBO0lBQ1gsc0JBQVcsQ0FBQTtJQUNYLHNCQUFXLENBQUE7QUFDYixDQUFDLEVBTFcsT0FBTyxLQUFQLE9BQU8sUUFLbEI7QUFFRDs7R0FFRztBQUNILE1BQU0sQ0FBTixJQUFZLGNBTVg7QUFORCxXQUFZLGNBQWM7SUFDeEIsK0JBQWEsQ0FBQTtJQUNiLG1DQUFpQixDQUFBO0lBQ2pCLG1DQUFpQixDQUFBO0lBQ2pCLHFDQUFtQixDQUFBO0lBQ25CLCtCQUFhLENBQUE7QUFDZixDQUFDLEVBTlcsY0FBYyxLQUFkLGNBQWMsUUFNekI7QUFFRDs7R0FFRztBQUNILE1BQU0sQ0FBTixJQUFZLGVBR1g7QUFIRCxXQUFZLGVBQWU7SUFDekIsa0NBQWUsQ0FBQTtJQUNmLGtDQUFlLENBQUE7QUFDakIsQ0FBQyxFQUhXLGVBQWUsS0FBZixlQUFlLFFBRzFCO0FBRUQ7O0dBRUc7QUFDSCxNQUFNLENBQU4sSUFBWSxrQkFHWDtBQUhELFdBQVksa0JBQWtCO0lBQzVCLGlDQUFXLENBQUE7SUFDWCxtQ0FBYSxDQUFBO0FBQ2YsQ0FBQyxFQUhXLGtCQUFrQixLQUFsQixrQkFBa0IsUUFHN0I7QUFFRDs7R0FFRztBQUNILE1BQU0sQ0FBTixJQUFZLGlCQUdYO0FBSEQsV0FBWSxpQkFBaUI7SUFDM0IsZ0NBQVcsQ0FBQTtJQUNYLGtDQUFhLENBQUE7QUFDZixDQUFDLEVBSFcsaUJBQWlCLEtBQWpCLGlCQUFpQixRQUc1QjtBQUVEOztHQUVHO0FBQ0gsTUFBTSxDQUFOLElBQVksYUFJWDtBQUpELFdBQVksYUFBYTtJQUN2QixtQ0FBa0IsQ0FBQTtJQUNsQix1Q0FBc0IsQ0FBQTtJQUN0QixxQ0FBb0IsQ0FBQTtBQUN0QixDQUFDLEVBSlcsYUFBYSxLQUFiLGFBQWEsUUFJeEIifQ==